import {
  createTRPCClient,
  httpBatchLink,
  httpLink,
  splitLink,
} from '@trpc/client'

import type { ProxyRouter } from './proxy.server'

const links = [
  splitLink<ProxyRouter>({
    condition(op) {
      return op.context.skipBatch as boolean
    },
    true: httpLink({ url: '/trpc' }),
    false: httpBatchLink({ url: '/trpc' }),
  }),
]

export const proxyTrpc = createTRPCClient<ProxyRouter>({
  links,
})
